declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

@Component({
  selector: 'pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.scss'],
  animations: [routerTransition()]
})

export class PickUpComponent implements OnInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  public OvumPickupdateNew: Date;
  public ActivityCodenew: number;
  public ReceipientActorCode: number;
  //

  
 

 
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }
    CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
    FollicularPickupEndInfo: FollicularPickUpsByCodeController;
    CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

    LoadOvariesData() {
        //alert("ScansData")
        this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularPickUpsByCodeController();
    }

    GetFollicularPickUpsByCodeController() {
        this.StartRefreshing();
        this.CurrentFollicularPickUpsByCodeRequest.ConditionalOperator = 20;
        this.CurrentFollicularPickUpsByCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.CycleCode;
        //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
        //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
        //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
        //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
        //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
        //alert(this.FormattedCode);
        this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
                  this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
                  this.OvumPickupdateNew = this.FollicularPickupEndInfo.OvulationTriggerDate;

                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                  this.LoadPatients();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    //alert("pickup");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ReceipientActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadMasterReq();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
  ActivityCodeInfo: TreatmentCycleActiityMasterController;
  CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

  LoadMasterReq() {
    //alert("Pickup");
    this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleActiityMasterController();
  }

  GetTreatmentCycleActiityMasterController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.FollicularPickupEndInfo.TreatmentCycle;
    this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
          //this.ActivityCodeInfo = this.CurrentTreatmentCycleActiityMasterController[0];
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadTestData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.GetCycleActivity(this.ActorCode, this.ScanDate);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, OvumPickupdateNew: Date): TreatmentCycleActiityMasterController[] {
    //alert(ReceipientActorCode);
    //alert(OvumPickupdateNew);
    return this.CurrentTreatmentCycleActiityMasterController.filter(
      function (v, i, d) {

        return v.ActorID == ReceipientActorCode && v.DocDate == OvumPickupdateNew;
      }
    )

  }

  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("TestsData");
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
      this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
      this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
      this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.OvumPickupdateNew)[0].CycleActivityCode;
    this.ActivityCodenew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();          

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.LoadOvariesData();
    
    
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  

  

  

 
  
  //
 
  //

  
 



  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  printpickup() {
    //this.router.navigate(['print/pickupdetails', { PickupCodeData: this.SelectedpatientDetails.PickUpCode, Owner: this.SelectedpatientDetails.OwnerName, CycleNo: this.SelectedpatientDetails.CycleNo, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientID: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName }]);
    this.printService.printDocument("pickupdetails",
      {
        PickupCodeData: this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode, CycleCodeData: this.FollicularPickupEndInfo.TreatmentCycle, ActorCodeData: this.SelectedTreatmentCycle.OwnerPatientRegistrationNo, Owner: this.SelectedTreatmentCycle.OwnerName, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientID: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        OvulationTriggerTime: this.FollicularPickupEndInfo.OvulationTriggerTime, OvulationTriggerDate: this.FollicularPickupEndInfo.OvulationTriggerDate, MedicineName: this.FollicularPickupEndInfo.MedicineName, Dosage: this.FollicularPickupEndInfo.Dosage, SurgeonName: this.FollicularPickupEndInfo.SurgeonName, AsstSurgeonName: this.FollicularPickupEndInfo.AsstSurgeonName, AnaesthesiaType: this.FollicularPickupEndInfo.AnaesthesiaType, AnesthesiologistName: this.FollicularPickupEndInfo.AnesthesiologistName, NeedleUsed: this.FollicularPickupEndInfo.NeedleUsed,
        Route: this.FollicularPickupEndInfo.Route, Complications: this.FollicularPickupEndInfo.Complications, MinPickupSize: this.FollicularPickupEndInfo.MinPickupSize, PickupSizeUnits: this.FollicularPickupEndInfo.PickupSizeUnits, OvumPlannedPickupDate: this.FollicularPickupEndInfo.OvumPlannedPickupDate, OvumPickupdate: this.FollicularPickupEndInfo.OvumPickupdate, OvumPickupTime: this.FollicularPickupEndInfo.OvumPickupTime, RFollicleCount: this.FollicularPickupEndInfo.RFollicleCount, LFollicleCount: this.FollicularPickupEndInfo.LFollicleCount,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, ActivityCodeData: this.ActivityCodenew, FollicularGrowthCodeData: this.FollicularPickupEndInfo.FollicularGrowth, RFollicleAspirated: this.FollicularPickupEndInfo.RFollicleAspirated, LFollicleAspirated: this.FollicularPickupEndInfo.LFollicleAspirated, TotalRtOocytes: this.FollicularPickupEndInfo.TotalRtOocytes, TotalLtOocytes: this.FollicularPickupEndInfo.TotalLtOocytes, TotalOocytes: this.FollicularPickupEndInfo.TotalOocytes,
      }

    );
  }
  
}
